if (!customElements.get('two-up-mixed-blocks-mobile')) {
  class TwoUpMixedBlocksMobile extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.button = this.querySelector('button');
      this.bigMedia = this.querySelector('.big-media');
      this.handleClick = this.handleClick.bind(this);

      this.button?.addEventListener('click', this.handleClick);
    }

    disconnectedCallback() {
      this.button?.removeEventListener('click', this.handleClick)
    }

    handleClick(event) {
      event.preventDefault();
      if (this.bigMedia.classList.contains('opacity-0')) {
        this.bigMedia.classList.remove('opacity-0');

        this.button.lastElementChild.classList.remove('opacity-0');

      } else {
        this.bigMedia.classList.add('opacity-0');

        this.button.lastElementChild.classList.add('opacity-0');

      }
    }
  }
  
  customElements.define('two-up-mixed-blocks-mobile', TwoUpMixedBlocksMobile);
}
